import React from 'react';

import { Button, ButtonProps, useMantineTheme } from '@mantine/core';
import { IconCalendarTime } from '@tabler/icons-react';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { CalendlyToolConfig } from 'shared/interfaces/tools/Calendly';
import { ToolConfig, ToolKind, ToolTrigger } from 'shared/interfaces/tools/Tool';

interface CalendlyButtonProps extends ButtonProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  toolConfigs?: ToolConfig[];
  forcedCalendlyToolConfig?: CalendlyToolConfig;
}

export function CalendlyButton({
  smartAssistantVisualConfig,
  toolConfigs,
  forcedCalendlyToolConfig,
  ...buttonProps
}: CalendlyButtonProps) {
  const theme = useMantineTheme();

  const calendlyToolConfig =
    forcedCalendlyToolConfig ??
    (toolConfigs?.find(
      (toolConfig) => toolConfig.kind === ToolKind.CALENDLY && toolConfig.trigger === ToolTrigger.BUTTON
    ) as CalendlyToolConfig | undefined);

  if (!calendlyToolConfig) return null;

  const assistantTextColor = theme.other.getReadableColor(smartAssistantVisualConfig.assistantMessageColor);

  const openCalendly = () => {
    if (!calendlyToolConfig.eventUrl) return;

    window.open(calendlyToolConfig?.eventUrl, '_blank');
  };

  return (
    <Button
      style={{
        backgroundColor: smartAssistantVisualConfig.assistantMessageColor,
        color: assistantTextColor
      }}
      px="md"
      leftIcon={<IconCalendarTime />}
      onClick={openCalendly}
      size="xs"
      {...buttonProps}>
      {calendlyToolConfig?.ctaMessage}
    </Button>
  );
}
